import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=76bb6e33&"
import script from "./ImageGallery.vue?vue&type=script&lang=js&"
export * from "./ImageGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76bb6e33')) {
      api.createRecord('76bb6e33', component.options)
    } else {
      api.reload('76bb6e33', component.options)
    }
    module.hot.accept("./ImageGallery.vue?vue&type=template&id=76bb6e33&", function () {
      api.rerender('76bb6e33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/gallery/ImageGallery.vue"
export default component.exports